import ready from '../utils/ready';

const initializeGrid = () => {
  // Hide navigation buttons if less than two items
  const overflowGrid = document.querySelectorAll<HTMLDivElement>('.overflow-grid');

  overflowGrid.forEach((grid) => {
    const numberOfItems = parseInt(
      window.getComputedStyle(grid).getPropertyValue('--overflow-grid-items') || '1',
      10
    );
    const items = grid.querySelectorAll<HTMLLIElement>('.overflow-grid__item');

    if (items.length <= numberOfItems) {
      grid.querySelectorAll<HTMLDivElement>('.overflow-grid__nav').forEach((nav) => {
        nav.style.display = 'none';
      });
    }
  });

  // Scroll Prev
  document
    .querySelectorAll<HTMLDivElement | HTMLButtonElement>(
      '.overflow-grid__nav--prev .overflow-grid__nav-btn'
    )
    .forEach((el) => {
      el.addEventListener('click', () => {
        const listWrapper = el
          ?.closest('.overflow-grid')
          ?.querySelector<HTMLUListElement>('.overflow-grid__list');
        if (listWrapper) {
          const scrollLeft = listWrapper.scrollLeft;
          const scrollDist =
            scrollLeft -
            listWrapper.querySelectorAll<HTMLLIElement>('.overflow-grid__item')[0].offsetWidth;

          if (scrollLeft > 0) {
            listWrapper.scrollTo({
              left: scrollDist,
              behavior: 'smooth',
            });
          }
        }
      });
    });

  // Scroll Next
  document
    .querySelectorAll<HTMLDivElement | HTMLButtonElement>(
      '.overflow-grid__nav--next .overflow-grid__nav-btn'
    )
    .forEach((el) => {
      el.addEventListener('click', () => {
        const listWrapper = el
          ?.closest('.overflow-grid')
          ?.querySelector<HTMLUListElement>('.overflow-grid__list');
        if (listWrapper) {
          const scrollLeft = listWrapper.scrollLeft;
          const scrollDist =
            listWrapper.querySelectorAll<HTMLLIElement>('.overflow-grid__item')[0].offsetWidth +
            scrollLeft;

          listWrapper.scrollTo({
            left: scrollDist,
            behavior: 'smooth',
          });
        }
      });
    });
};

ready(initializeGrid);
